// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "single/assets/" + {"104":"8488657ae6754d08cfd9","168":"b8a3fbf3124f49bcbd6f","303":"02cecc653bad5027c865","411":"05023290fa56c1019efc","619":"75eb6d6e858a12a9d195","956":"3ff07a755476e9316a47"}[chunkId] + "." + chunkId + ".js";
};